export default __webpack_public_path__ + "static/media/quickeningdeath.0cd24968.png";